module.exports = __webpack_public_path__ + "img/csot.fc3a2927.png";